module.exports = __webpack_public_path__ + "media/components/application/PaymentCard/icons/mastercard-0f0642519edcab8ccba5ccb2d841e9ac.svg";